import GUID from 'bz-utilities/modules/variables/guid';
import { action, computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import React from 'react';
import featureFlag from 'tm3-core/stores/feature-store';

import './style.css';

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Icon, Text, View } from '@zinc/ui';
import ReportsMenu from './controls/reports-menu';

interface IProps {
  clinicalStore?: any;
}

@inject('clinicalStore')
@observer
class Footer extends React.Component<IProps> {
  @observable open = true;

  render() {
    if (!this.show) {
      return null;
    }

    return (
      <View paddingTop={2}>
        <View padding={4} backgroundColor="page" borderRadius="medium" shadow="raised">
          <View direction="row" gap={2} justify="space-between" align="center">
            <View direction="row" gap={2} align="center">
              <Icon color="neutral-faded" size={6} svg={<FontAwesomeIcon icon={faCircleInfo} />} />
              <Text color="neutral-faded" variant="body-2" weight="medium">
                This case has been referred by: <u>{this.name}</u>
              </Text>
            </View>
            <View direction="row" gap={2} align="center">
              <ReportsMenu />
              <Button variant={'outline'} size="small" onClick={this.onClose}>
                Hide
              </Button>
            </View>
          </View>
          <View direction="row" justify="end"></View>
        </View>
      </View>
    );
  }

  @computed
  get allowed() {
    let { prontoStore } = this.props.clinicalStore;
    return !!Array.from(prontoStore.allowed.values()).find((x) => GUID.hasValue(x));
  }

  @computed
  get show() {
    let { details, referralStore } = this.props.clinicalStore.caseStore;
    let { closed, bookingAuditId } = details || {};

    if (!this.open) {
      return false;
    }

    const isProntoReport = featureFlag.prontoIntegrationEnabled && GUID.hasValue(bookingAuditId);
    const canReportToPronto = !!referralStore && referralStore.referral.canReport;
    return !closed && isProntoReport && !!this.allowed && !!canReportToPronto;
  }

  @computed
  get name() {
    return this.props.clinicalStore.prontoStore.name;
  }

  @action.bound
  onClose() {
    this.open = false;
  }
}

export default Footer;
